import { AccountOwnerState } from './reducer';

export const getAccountOwner = (state: any): string | undefined =>
    (state.accountOwner as AccountOwnerState | undefined)?.subject;
